import type { UseQueryOptionsWithoutQueryKey } from '../../react-query-config'
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios'
import { useQuery } from '@tanstack/react-query'
import type { ResponseApiError } from '../../models/axios-error'

export interface UseApiGetCurrentWeekGoalIndicatorsRequest {
  channel: 'INSTORE' | 'OMNI'
  aggregation: 'TEAM' | 'STORE'
  storeId: number
  teamId: number | null
}

export type GoalStatus = 'GOOD' | 'MEDIUM' | 'BAD'

export interface CurrentWeekGoalIndicatorsResponse {
  goalStatus: GoalStatus
  probable: number
  forecasted: number
  realizedOnError: boolean
  forecastOnError: boolean
}

const getCurrentWeekGoalIndicators = async (config: AxiosRequestConfig): Promise<CurrentWeekGoalIndicatorsResponse> => {
  const axiosPromise: AxiosResponse<CurrentWeekGoalIndicatorsResponse> = await axios(config)
  return {
    ...axiosPromise.data
  }
}

export const useApiGetCurrentWeekGoalIndicators = (
  args: UseApiGetCurrentWeekGoalIndicatorsRequest,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<CurrentWeekGoalIndicatorsResponse>
) => {
  const { storeId, teamId, channel, aggregation } = args
  const teamParam = aggregation === 'TEAM' && teamId !== null ? `&teamId=${teamId}` : ''
  const url = `/v1/current-week-goal-indicators?aggregation=${aggregation}&channel=${channel}&storeId=${storeId}${teamParam}`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<CurrentWeekGoalIndicatorsResponse, ResponseApiError>({
    queryKey: ['get-current-week-goal-indicators', url],
    queryFn: () => getCurrentWeekGoalIndicators(config),
    enabled,
    ...options
  })
}
